import axios from 'axios';
import { getDaysLimit } from '@/shared/lib/welcomeBonus/helpers';

export async function getOperationsDictionary() {
  return axios.get('/api/dictionary/operations');
}

export async function getBonusByPhone(phone: string) {
  return axios.get('/api/contacts/welcomeBonus', {
    params: {
      phone,
    },
  });
}

export async function getOperationsForBonus(email: string, operationId: number[]) {
  return axios.get('v2/api/operations', {
    params: {
      email,
      operationId: operationId.join(),
      startDate: getDaysLimit(),
    },
  });
}
